// src/components/investments/InvestmentSection.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InvestmentCard from './InvestmentCard';
import { API_ENDPOINTS } from '../../config';

const InvestmentSection = ({ 
  type: sectionType,
  title,
  description,
  bgColor = 'bg-white' 
}) => {
  console.log('🔍 InvestmentSection props:', { sectionType, title, description, bgColor });
  
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log('🔄 Fetching data for:', sectionType);
    fetchData();
  }, [sectionType]);
  
  const fetchData = async () => {
    try {
      console.log('📡 API call for type:', sectionType);
      
      if (sectionType === 'creators') {
        const response = await fetch(`${API_ENDPOINTS.investments.creators || 'https://svc.choicemcn.com/api/creators/investment-opportunities'}`);
        console.log('📥 Creators response:', response.ok);
        if (response.ok) {
          const data = await response.json();
          console.log('📊 Creators data:', data);
          setItems((data.creators || []).slice(0, 6));
        }
      } else {
        const response = await fetch(API_ENDPOINTS.investments.opportunities);
        console.log('📥 Projects response:', response.ok);
        if (response.ok) {
          const data = await response.json();
          console.log('📊 Projects data:', data);
          const projects = data.projects || data || [];
          
         let filtered = [];
          if (sectionType === 'network') {
            // Show high-progress entertainment projects
            filtered = projects.filter(p => 
              p.category === 'ENTERTAINMENT' && 
              p.progressPercentage >= 50
            );
          } else if (sectionType === 'external') {
            // Show technology and education projects
            filtered = projects.filter(p => 
              (p.category === 'TECHNOLOGY' || p.category === 'EDUCATION')
            );
          } else if (sectionType === 'funding') {
            // Show projects needing funding (low progress)
            filtered = projects.filter(p => 
              p.progressPercentage < 50
            );
          }
          
          console.log(`✅ Filtered ${sectionType} items:`, filtered.length, filtered);
          setItems(filtered.slice(0, 6));
        }
      }
    } catch (error) {
      console.error(`❌ Error fetching ${sectionType} data:`, error);
    } finally {
      setLoading(false);
    }
  };
  
  console.log('📦 Current state - loading:', loading, 'items:', items.length);
  
  if (loading) {
    return (
      <section className={`py-16 lg:py-24 ${bgColor}`}>
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            <p className="mt-4 text-slate-600">Loading {sectionType} opportunities...</p>
          </div>
        </div>
      </section>
    );
  }
  
  if (items.length === 0) {
    console.log(`⚠️ ${sectionType} section hidden - no items`);
    return null;
  }
  
  console.log(`✨ ${sectionType} section rendering with`, items.length, 'items');
  
  return (
    <section className={`py-16 lg:py-24 ${bgColor}`}>
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <h2 className="text-3xl font-extrabold text-slate-900">
            {title}
          </h2>
          <p className="mt-3 text-lg text-slate-600" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
        
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item) => (
            <InvestmentCard 
              key={item.id} 
              item={item} 
              type={sectionType === 'creators' ? 'creator' : sectionType} 
            />
          ))}
        </div>
        
        <div className="mt-8 text-center">
          <button
            onClick={() => navigate('/investment-opportunities')}
            className="px-6 py-3 rounded-lg text-white font-semibold bg-gradient-to-r from-blue-600 to-purple-600 hover:shadow-lg transition-all inline-block"
          >
            View All {title}
          </button>
        </div>
      </div>
    </section>
  );
};

export default InvestmentSection;